import {
    blue_600,
    blue_700,
    red_600,
    red_900,
    orange_800,
    orange_1000,
    teal_900,
    teal_1000,
    pink_900,
    pink_1000,
    purple_600,
    purple_800,
    yellow_1000,
    yellow_1100,
} from '@fiverr-private/sass/helpers';

export const AVATAR_BACKGROUND_COLORS = {
    blue_600,
    blue_700,
    red_600,
    red_900,
    orange_800,
    orange_1000,
    teal_900,
    teal_1000,
    pink_900,
    pink_1000,
    purple_600,
    purple_800,
    yellow_1000,
    yellow_1100,
} as const;

export const AVATAR_SIZES = {
    xs: 24,
    sm: 32,
    md: 48,
    lg: 64,
    xl: 80,
    '2xl': 120,
    '3xl': 160,
} as const;

export const RING_SIZE_FACTOR = 0.05;

export const ROUNDED_FULL = '50%';

export const HALF = 0.5;
